<template>
  <div class="row">
    <label class="ls-label">
      <span class="ls-label-text col-xs-12">{{ $t('settings.label.webhook_setting') }}</span>
      <div class="col-xs-12 col-md-7 col-sm-7 col-lg-7">
        <div class="ls-custom-select">
          <select v-model="$parent.$parent.$data.selectedWebhookSetting" class="ls-select" @change.prevent="changeWebhookSetting()">
            <option value="9">{{ $t('settings.webhook_attributes.invoice') }}</option>
            <option value="10">{{ $t('settings.webhook_attributes.contract') }}</option>
          </select>
        </div>
      </div>
    </label>
  </div>
</template>
<script>
  import { mapMutations } from 'vuex'

  export default {
    methods: {
      ...mapMutations(['clearFlash']),
      changeWebhookSetting () {
        this.clearFlash()
        this.$parent.$parent.getWebhookSetting(this.$parent.$parent.$data.selectedWebhookSetting)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SelectWebhookSetting.vue?02685ef6